/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PeopleIcon extends BaseIcon {
  getChildren = () => [ <path d="M5.13,3A2.17,2.17,0,1,0,7.31,5.17,2.17,2.17,0,0,0,5.13,3ZM11,3a2.17,2.17,0,1,0,2.18,2.17A2.17,2.17,0,0,0,11,3ZM5,8.66c-2.14,0-5,1.06-5,2.53V13H10V11.19C10,9.72,7.14,8.66,5,8.66Zm6.33,0-.65,0A3.16,3.16,0,0,1,12,11.19V13h4V11.19C16,9.72,13.33,8.66,11.33,8.66Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
